import { Bottomsheet } from '@com/modal/containers/Bottomsheet';
import { ClinicProfile, UserServiceItem } from '@models/clinic-list';

import ServiceBookingCalendar from './ServiceBookingCalendar';
import { DoctorClinicItemModel } from '@models/in-person-booking';

type ServiceBookingBottomsheetProps = {
  profile: ClinicProfile;
  service?: UserServiceItem;
  profileId: number;
  clinic?: DoctorClinicItemModel;
};

const ServiceBookingBottomsheet = ({
  profile,
  service,
  profileId,
  clinic,
}: ServiceBookingBottomsheetProps) => {
  return (
    <Bottomsheet
      className="!overflow-hidden flex flex-col justify-between"
      height="auto"
      maxHeight={'calc(100vh - 100px)'}
      hasCloseButton
      title="انتخاب نوبت"
    >
      <ServiceBookingCalendar
        profile={profile}
        service={service}
        profileId={profileId}
        clinic={clinic}
      />
    </Bottomsheet>
  );
};

export default ServiceBookingBottomsheet;
